export default function BulkArchiveGeneratedReportInstancesConfirmDialogController(
  $q,
  $rootScope,
  $scope,
  alerts,
  reportsDataService,
  loaderService,
  ssDialogService
) {
  const vm = this;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleConfirmArchive = _handleConfirmArchive;

  _activate();

  // //////// METHODS //////////

  function _activate() {
  }

  /** *********************************************
   * Event Handlers
   */

  function _handleCloseDialog($event) {
    _closeDialog($event);
  }

  function _handleConfirmArchive($event) {
    loaderService.showViewLoader = true;
    const idList = {};
    idList.ids = vm.reportInstanceIds;
    return reportsDataService.bulkArchiveReportInstances(idList).then(() => {
      alerts.success('All selected Report Instances were successfully archived.');
      $rootScope.$broadcast(`reports.generatedReports.reportType.reportInstancesArchived`, { uniqueId: vm.reportTypeId });
      _closeDialog($event);
      ssDialogService.hide(ssDialogService.dialogs.reports.bulkArchiveGeneratedReportInstancesDialog);
    }).catch(() => {
      alerts.error('An error occurred while deleting the selected Report Instances.');
    }).finally(() => {
      loaderService.showViewLoader = false;
    });
  }

  /** *********************************************
   * Private Functions
   */

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.assetAdmin.bulkArchiveGeneratedReportInstancesConfirmDialog);
  }
}

BulkArchiveGeneratedReportInstancesConfirmDialogController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'reportsDataService',
  'loaderService',
  'ssDialogService'
];
